import { Table, TableContainer, useTheme, CircularProgress, Chip, Dialog, DialogTitle, DialogContent, Stack, LinearProgress, TableCell, TableHead, TableRow, TableBody, Grid, Divider, Typography, TextField, Button, Autocomplete, FormControl, Checkbox, Tooltip, IconButton, Box, Card, CardHeader, CardContent, Input, Select, } from "@mui/material";
import React, { useEffect, useState } from "react";

// template
import Header from "../../../Layout/Header";
import CallAlertBar from "../../../Layout/Alertbar";
import CustomTableContainer from "../../../components/table/CustomTableContainer";

//icons
import AddCircleIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

//services
import AddStorageLocation from "../../master/AddStorageLocation";
import useStorageLocation from "../../../hooks/useStorageLocationList";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import StorageLocationActionMenu from "./ActionMenu";
import ViewStorageLocationReportBySONumber from "../reports/StorageLocationReport";

// Date picker components
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { alpha, styled } from '@mui/material/styles';

// Utilities
import dayjs from 'dayjs';
import 'dayjs/plugin/customParseFormat';
import { useTranslation } from "react-i18next";
import GlobalConfig from "../../../config/date/GlobalConfig";
import useGetSONumberList from "../../../hooks/useStoreFGSalesOrderList";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import useProductionTracking from "../../../hooks/useProductionTrackking";
import { exportToExcel } from "../../../components/ExportToExcel";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import TableFilterRow from "../../../components/table/TableFilterRow";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import useDefaultParameterConfig from "../../../hooks/useDefaultParameterConfig";
import { Production_API_ENDPOINTS } from "../../../config/api/apiCallProduction";
import { Warehouse_API_ENDPOINTS } from "../../../config/api/apiCallWarehouse";
import usePackageTypeListBySONumber from "../../../hooks/usePackageTypeListBySONumber";
import { ArrowRightAlt, ArrowRightAltOutlined, ArrowRightTwoTone, CalendarViewDayRounded, Filter1Outlined, FilterAlt, Info, Label, RefreshOutlined, RefreshRounded, Update, UpdateRounded, Warehouse, WarehouseOutlined } from "@mui/icons-material";

import { toast } from "react-toastify";
import { useWarehouseBinUsage } from "../../../hooks/warehouse/useWarehouseBinUsage";
import { useSOWiseLocationList } from "../../../hooks/warehouse/useSOWiseLocationList";

const AddStorageLocationForFGWarehouse = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { t } = useTranslation();
    const userPermissions = useUserPermissions();

    // message Process
    const [msgOpen, setMsgOpen] = useState(false);
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [alertTitleValue, setAlertTitleValue] = useState('');


    const [soNumber, setSONumber] = useState('');
    const [editShiftAssignmentID, setShiftAssignmentID] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [productList, setProductList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const [selectedStatus, setSelectedStatus] = useState('All');
    const [viewList, setViewList] = useState(false);
    const [selectedButtonName, setSelectedButtonName] = useState('addLocation');

    const [viewReport, setViewReport] = useState(false);
    const [downloadReport, setdownloadReport] = useState(false);
    const [reportDetail, setReportDetail] = useState([]);
    const [isOpenPackageMode, setIsOpenPackageMode] = useState(false);
    const [isOpenWarehouseData, setIsOpenWarehouseData] = useState(false);

    // const { storageLocation, selectedStorageLocation, selectedStorageLocationID, setSelectedStorageLocation, setSelectedStorageLocationID, loadStorageLocationByID } = useStorageLocation(editShiftAssignmentID);
    const [storageLocation, setStorageLocation] = useState([]);
    const [selectedStorageLocation, setSelectedStorageLocation] = useState(null);
    const [selectedStorageLocationID, setSelectedStorageLocationID] = useState(null);


    const { packagetypelist, selectedPakcagetype, setSelectedPakcagetype, selectedPakcagetypeID, setSelectedPakcagetypeID, loadPackageTypeBySONumberAndID } = usePackageTypeListBySONumber();
    // Date range States

    const [filterFromDate, setFilterFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [filterToDate, setFilterToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [receivedDate, setReceivedDate] = useState(dayjs().format('DD/MMM/YYYY'));

    // skeleton progress 
    const [loading, setLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [disableFetchProduct, setDisableFetchProduct] = useState(true);
    const [disableSave, setDisableSave] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);

    const { salesOrderNumber, selectedSalesOrderNumber, setSelectedSalesOrderNumber, setSelectedSalesOrderNumberID, ddloading, } = useGetSONumberList(0);
    const { loadProductionTrackingBySOAndCRNumber } = useProductionTracking();
    const { defaultParameterConfig } = useDefaultParameterConfig();
    const [objectTypeList, setObjectTypeList] = useState([]);

    const [filteredObjectTypeList, setFilteredObjectTypeList] = useState([]);

    const [selectedObjectType, setSelectedObjectType] = useState(null);

    const [usedLengthInCM, setUsedLengthInCM] = useState(0);
    const [usedHeightInCM, setUsedHeightInCM] = useState(0);
    const [usedItemCount, setUsedItemCount] = useState(0);

    const [reverseHeightInCM, setreverseHeightInCM] = useState(0);
    const [reverseItemCount, setreverseItemCount] = useState(0);

    const [viewObjectType, setViewObjectType] = useState(false);

    const { binUsage, checkWarehouseBinUsage, setBinusage } = useWarehouseBinUsage();
    const { warehouseLocationListBySO, fetchWarhouseLocationListBySO, setWarehouseLocationListBySO, } = useSOWiseLocationList();

    const convertToCM = (value, unit) => {
        const num = Number(value);
        const u = unit?.toUpperCase();

        switch (u) {
            case "CM":
                return num;
            case "MM":
                return num / 10;
            case "INCH":
            case "IN":
                return num * 2.54;
            case "M":
            case "METER":
                return num * 100;
            default:
                return num; // if some weird unit comes
        }
    };


    const ValidateObjectSizeToFitInLocation = (object, selectedRows, binUsage) => {
        let sizeInCM = 0;
        let usedHeightInCM = 0;

        if (binUsage[0].is_stackable) {
            let selectedProducts;
            if (selectedRows.length > 0) {
                selectedProducts = productList.filter((p) => selectedRows.includes(p.id_product));

                usedHeightInCM = selectedProducts.reduce((sum, item) => {
                    const size = item.size?.toString() || "";      // safe

                    let firstVal;

                    if (size.includes("X") || size.includes("x")) {
                        firstVal = parseFloat(size.toUpperCase().split("X")[0].trim());
                    } else {
                        firstVal = parseFloat(size.trim());
                    }

                    return sum + (isNaN(firstVal) ? 0 : firstVal);
                }, 0);
            }


            if (binUsage[0].height_in_cm == 0) {
                return { ok: false, msg: "Stackable bin needs a height. Zero ain't valid." };
            }


            let totalUsedAfterAdd = usedHeightInCM + binUsage[0].used_height_in_cm;

            if (totalUsedAfterAdd > binUsage[0].height_in_cm) {

                // 🔹 otherwise, it's really too large
                let freeSpaceLeft =
                    binUsage[0].height_in_cm -
                    (binUsage[0].used_height_in_cm);

                if (freeSpaceLeft < 0) freeSpaceLeft = 0;

                freeSpaceLeft = Number(freeSpaceLeft.toFixed(2));

                return {
                    ok: false,
                    msg: `Object too large (${usedHeightInCM}cm) — only ${freeSpaceLeft} cm free space available in this location.`,
                };
            }

            setUsedHeightInCM(usedHeightInCM + binUsage[0].used_height_in_cm);
            if (selectedProducts) {
                setUsedItemCount(selectedProducts.length + binUsage[0].used_item_count);
            }
            else {
                setUsedItemCount(binUsage[0].used_item_count);
            }

        }
        else {


            sizeInCM = convertToCM(object.object_length, object.object_unit);

            // 🔹 calculate how much total space would be used *with gap*
            let totalUsedAfterAdd =
                binUsage[0].used_length_in_cm +
                binUsage[0].vertical_gap_in_cm +
                sizeInCM;

            // 🔹 if adding this object exactly fills or exceeds available length
            // but without needing a gap (like last object), then ignore the gap
            if (totalUsedAfterAdd > binUsage[0].length_in_cm) {
                // check if it fits exactly *without* vertical gap
                const totalUsedWithoutGap =
                    binUsage[0].used_length_in_cm + sizeInCM;

                if (totalUsedWithoutGap <= binUsage[0].length_in_cm) {
                    // it fits perfectly — no problem, allow it
                    setUsedLengthInCM(totalUsedWithoutGap);
                    return { ok: true };
                }

                // 🔹 otherwise, it's really too large
                let freeSpaceLeft =
                    binUsage[0].length_in_cm -
                    (binUsage[0].used_length_in_cm + binUsage[0].vertical_gap_in_cm);

                if (freeSpaceLeft < 0) freeSpaceLeft = 0;

                freeSpaceLeft = Number(freeSpaceLeft.toFixed(2));

                return {
                    ok: false,
                    msg: `Object too large (${binUsage[0].vertical_gap_in_cm + sizeInCM}cm) — only ${freeSpaceLeft} cm free space available in this location.`,
                };
            }



            setUsedLengthInCM(totalUsedAfterAdd);
            setUsedItemCount(1);
        }

        return { ok: true }
    }




    const LoadObjectTypeList = async () => {

        const payload = {
            p_company_id: localStorage.getItem('companyid'),
            p_plant_id: 1,
            p_status: true
        };

        callApi(Warehouse_API_ENDPOINTS.objectType.getListByStatus, 'POST',
            { 'Content-Type': 'application/json' }, payload)
            .then((data) => {
                if (data && data.length > 0) {
                    setObjectTypeList(data);


                } else {

                    CallMessage('warning', 'No Object Types data found!', 'Warning');
                }
            })
            .catch(() => {

                CallMessage('warning', 'Unable to load Object Type details!', 'Warning');
            });
    };

    useEffect(() => {
        LoadObjectTypeList();
    }, []);


    // table sample data 

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });



    const handleCallBack = () => {
        handleBackWinderMachineEntry();
    }
    // department change
    const handleStorageLocationChange = async (event, value) => {
        if (!value) {
            setSelectedStorageLocation(null);
            setSelectedStorageLocationID(null);
            return; // Exit early if value is null
        }

        setSelectedStorageLocation(value);
        setSelectedStorageLocationID(value.location_id);
        //await checkWarehouseBinUsage(value.location_id)

        // Then run your validation logic
        await handleValidateBinUsage(
            selectedObjectType,
            selectedRows,
            value.location_id // pass the selected location ID
        );




    };


    // useEffect(() => {
    //     if (binUsage.length > 0 && selectedObjectType) {
    //         await checkWarehouseBinUsage(value.location_id)
    //         let result = ValidateObjectSizeToFitInLocation(binUsage[0], selectedObjectType, selectedRows);

    //         if (!result.ok) {
    //             CallMessage("warning", result.msg, "Warning");
    //             setDisableSave(true);
    //         } else {
    //             setDisableSave(false);
    //             setMsgOpen(false);
    //         }
    //     }
    // }, [binUsage, selectedObjectType, selectedRows]);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         if (binUsage.length > 0 && selectedObjectType) {
    //             await checkWarehouseBinUsage(selectedStorageLocationID);
    //             let result = ValidateObjectSizeToFitInLocation(binUsage[0], selectedObjectType, selectedRows);

    //             if (!result.ok) {
    //                 CallMessage("warning", result.msg, "Warning");
    //                 setDisableSave(true);
    //             } else {
    //                 setDisableSave(false);
    //                 setMsgOpen(false);
    //             }
    //         }
    //     }
    //     fetchData();
    // }, [binUsage, selectedObjectType, selectedRows]);

    // const handleValidateBinUsage = async (
    //     selectedObjectType,
    //     selectedRows,
    //     selectedStorageLocationID,
    // ) => {
    //     if (selectedObjectType && selectedStorageLocationID) {
    //         await checkWarehouseBinUsage(selectedStorageLocationID);

    //         if (binUsage.length > 0) {
    //             const result = ValidateObjectSizeToFitInLocation(
    //                 binUsage[0],
    //                 selectedObjectType,
    //                 selectedRows
    //             );

    //             if (!result.ok) {
    //                 CallMessage("warning", result.msg, "Warning");
    //                 setDisableSave(true);
    //             } else {
    //                 setDisableSave(false);
    //                 setMsgOpen(false);
    //             }
    //         }

    //     }
    // };

    const handleValidateBinUsage = async (
        selectedObjectType,
        selectedRows,
        selectedStorageLocationID
    ) => {

        if (selectedObjectType && selectedStorageLocationID) {

            // here this process to get free space
            const fetchedBinUsage = await checkWarehouseBinUsage(selectedStorageLocationID); // 🔥 use returned data


            if (fetchedBinUsage.length > 0) {
                const result = ValidateObjectSizeToFitInLocation(
                    selectedObjectType,
                    selectedRows,
                    fetchedBinUsage
                );

                if (!result.ok) {
                    CallMessage("warning", result.msg, "Warning");
                    setDisableSave(true);
                    return { ok: false, msg: result.msg }; // ⬅ return failure
                } else {
                    setDisableSave(false);
                    setMsgOpen(false);
                    return { ok: true }; // ⬅ return success
                }
            }
        }

        // If required data missing
        return { ok: false, msg: "Missing data for validation." };
    };








    const handleObjectTypeChange = async (event, value) => {
        if (!value) {
            setSelectedObjectType(null);

            return; // Exit early if value is null
        }


        setSelectedObjectType(value);

        // Trigger validation if other required data exists
        await handleValidateBinUsage(
            value, // the new selected object type
            selectedRows,
            selectedStorageLocationID
        );
    };

    const handlePackageTypeChange = async (event, value) => {
        if (!value) {
            setSelectedPakcagetype(null);
            setSelectedPakcagetypeID(null);
            setIsOpenWarehouseData(false);
            setDisableFetchProduct(true);
            setViewList(false);

            return; // Exit early if value is null
        }

        setSelectedPakcagetype(value);
        setSelectedPakcagetypeID(value.line_no);
        setDisableFetchProduct(false);


        let SelectedSO = typeof selectedSalesOrderNumber === 'string'
            ? selectedSalesOrderNumber
            : selectedSalesOrderNumber?.so_number || '';

        await LoadDetailsAfterPackageModeSelected(value, SelectedSO);

    };

    const LoadDetailsAfterPackageModeSelected = async (value, so_number) => {


        if (so_number !== null && so_number !== '' && so_number !== undefined && value.line_no !== null) {
            await getWarehouseLocationsByOrderZone_SelectPackageType(value,so_number);
        }

        if (value.package_mode === 'REEL' || value.package_mode === 'RL') {
            setViewObjectType(false);

            // const reelItems = objectTypeList.filter(item => item.object_type == "REEL"); 
            // thiravidam change cheythath for RL also include cheyyan
            
            const reelItems = objectTypeList.filter(
                    item => item.object_type === "REEL" || item.object_type === "RL"
                );

            const defaultValue = reelItems.length > 0 ? reelItems[0] : null;
            setSelectedObjectType(defaultValue);


            // Trigger validation if other required data exists
            await handleValidateBinUsage(
                defaultValue, // the new selected object type
                selectedRows,
                selectedStorageLocationID
            );

        }
        else {
            setViewObjectType(true);
            setSelectedObjectType(null);

            // 🔥 Remove REEL items from the list
            const filteredList = objectTypeList.filter(item => item.object_type !== "REEL");
            setFilteredObjectTypeList(filteredList);
        }
    }

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        // loadStorageLocationByID(0);

    };

    const handleFilterFromDate = (date) => {
        setFilterFromDate(dayjs(date));
    };

    const handleFilterToDate = (date) => {
        setFilterToDate(dayjs(date));
    };

    // useEffect(() => {
    //     let SelectedSO = typeof selectedSalesOrderNumber === 'string'
    //         ? selectedSalesOrderNumber
    //         : selectedSalesOrderNumber?.so_number || '';

    //     if (SelectedSO !== null && SelectedSO !== '' && SelectedSO !== undefined && selectedPakcagetypeID !== null) {
    //         getWarehouseLocationsByOrderZone_SelectPackageType();
    //     }

    // }, [selectedSalesOrderNumber, selectedPakcagetypeID]);

    const getWarehouseLocationsByOrderZone_SelectPackageType = async (selectedPakcagetype,SelectedSO) => {



        const SaveData = {
            p_saleorder_no: SelectedSO,
            p_package_type: selectedPakcagetype.package_mode,
            p_company_id: localStorage.getItem('companyid'),
            p_plant_id: 1,
        }

        if (!viewReport) {
            setSaveLoading(true);
            callApi(Warehouse_API_ENDPOINTS.fgWarehouse.location_list, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setStorageLocation(data);
                        setMsgOpen(false);
                        setIsOpenWarehouseData(true);
                    }
                    else {
                        setStorageLocation([]);
                        setIsOpenWarehouseData(false);

                        if (selectedSalesOrderNumber.zone !== undefined) {
                            CallMessage('warning', `No warehouse location is available for the selected Order Zone (${selectedSalesOrderNumber.zone}) and Package Mode.`, 'Warning');
                        }


                    }
                })
                .catch(error => {
                    alert(error.message);

                });
        }


    }

    const handleFilterDataWithPackageMode = () => {

        let isValid = true;
        let errorMessage = "";



        let SelectedSO = typeof selectedSalesOrderNumber === 'string'
            ? selectedSalesOrderNumber
            : selectedSalesOrderNumber?.so_number || '';
        const SaveData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_so_number: SelectedSO,
            p_package_type: selectedPakcagetype.package_mode
        }


        if (!SelectedSO) {
            isValid = false;
            errorMessage = "Please select the SO Number.";
        } else if (!selectedPakcagetype) {
            isValid = false;
            errorMessage = "Please select the package mode.";
        }

        if (!isValid) {
            alert(errorMessage);
            return;
        }


        if (!viewReport) {
            setSaveLoading(true);
            callApi(API_ENDPOINTS.PRODUCTION_FILTER_DATA_SO_PACKAGE_TYPE, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setProductList(data);
                        setViewList(true);
                        setSelectedRows([]);
                        loadProductionTrackingBySOAndCRNumber(0, SelectedSO, '');
                        setSaveLoading(false);


                    }
                    else {
                        setProductList([]);
                        setViewList(false);
                        setSelectedRows([]);
                        setSaveLoading(false);
                    }
                })
                .catch(error => {
                    alert(error.message);
                    setSaveLoading(false);
                });
        }



    }

    const [filters, setFilters] = useState({
        product_code: '',
        item_code: '',
        gsm: '',
        size: '',
        grain: '',
        grade: '',
        store_code: '',
        customer_name: '',
        supplier_name: '',
        indent_no: '',
        product_type: '',
    });





    const filteredData = productList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    // const handleSelectAllClick = (event) => {
    //     if (event.target.checked) {
    //         //const newSelectedRows = productList.map((row) => row.id_product);
    //         const newSelectedRows = productList
    //             .filter((row) => row.store_code === null) // Exclude 'converted' rows
    //             .map((row) => row.id_product);
    //         setSelectedRows(newSelectedRows);
    //         return;
    //     }
    //     setSelectedRows([]);
    // };

    const selectableRows = productList.filter(row => row.store_code === null);

    const handleSelectAllClick = async (event) => {
        const selectableRows = productList.filter(row => row.store_code === null);

        let newSelectedRows = [];

        if (event.target.checked) {
            newSelectedRows = selectableRows.map(row => row.id_product);
        }

        setSelectedRows(newSelectedRows);

        if (selectedObjectType && selectedStorageLocationID) {
            await handleValidateBinUsage(
                selectedObjectType,
                newSelectedRows,
                selectedStorageLocationID
            );
        }
    };



    // const handleSelectAllClick = async (event) => {
    //     let newSelectedRows = [];

    //     if (event.target.checked) {
    //         newSelectedRows = productList
    //             .filter((row) => row.store_code === null) // exclude converted
    //             .map((row) => row.id_product);
    //     }

    //     setSelectedRows(newSelectedRows);

    //     // ✅ Run bin validation after updating selected rows
    //     if (selectedObjectType && selectedStorageLocationID) {
    //         await handleValidateBinUsage(
    //             selectedObjectType,
    //             newSelectedRows,
    //             selectedStorageLocationID
    //         );
    //     }
    // };


    const handleRowCheckboxClick = async (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

        // ✅ Trigger bin validation if all necessary values exist
        if (selectedObjectType && selectedStorageLocationID) {
            await handleValidateBinUsage(
                selectedObjectType,
                newSelectedRows, // use updated selection
                selectedStorageLocationID
            );
        }


    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;

    const totalSelectedWeight = filteredData
        .filter((s) => selectedRows.includes(s.id_product))
        .reduce((sum, row) => sum + (parseFloat(row.weight) || 0), 0)
        .toFixed(1); // Limits to 1 decimal place



    const saveStorageLocation = async () => {

        if (!hasPermission(userPermissions, "FG Report", "Create")) {
            console.warn("User does not have permission to perform this action.");
            return; // Exit the function if permission is not granted
        }

        let isValid = true;
        let errorMessage = "";

        const selectedProducts = productList.filter((p) => selectedRows.includes(p.id_product));

        // Get distinct product_type values
        const selectedProductType = [...new Set(selectedProducts.map((p) => p.product_type))];

        let maxFgDate = null;

        if (selectedProducts.length > 0) {
            maxFgDate = selectedProducts
                .map((p) => dayjs(p.fg_date, "DD-MMM-YYYY")) // Convert `fg_date` to `dayjs` object
                .reduce((max, date) => (date.isAfter(max) ? date : max), dayjs(selectedProducts[0].fg_date, "DD-MMM-YYYY"));

            // Format maxFgDate for consistency
            maxFgDate = maxFgDate.format("YYYY-MM-DD HH:mm:ss");
        }

        // Convert receivedDate to `dayjs` and format it in the same way
        const p_store_receive_date = dayjs(receivedDate).format("YYYY-MM-DD HH:mm:ss");

        // Ensure `p_store_receive_date` is not less than `maxFgDate`
        if (maxFgDate && dayjs(p_store_receive_date).isBefore(dayjs(maxFgDate))) {
            isValid = false;
            errorMessage = "Storage Received date cannot be earlier than the maximum FG date.";
        } else if (!maxFgDate) {
            isValid = false;
            errorMessage = "No valid fg_date found in selected products.";
        }


        // Extracting required parameters
        const companyID = localStorage.getItem('companyid')?.trim();
        const userID = localStorage.getItem('userID')?.trim();
        const plantID = 1;  // Assuming plant ID is always 1
        const locationID = selectedStorageLocationID;



        // Validating each parameter
        if (!companyID) {
            isValid = false;
            errorMessage = "Company ID is missing.";
        } else if (!userID) {
            isValid = false;
            errorMessage = "User ID is missing.";
        } else if (!selectedProducts || selectedProducts.length === 0) {
            isValid = false;
            errorMessage = "Please select at least one product.";
        } else if (!locationID) {
            isValid = false;
            errorMessage = "Storage location is not selected.";
        }



        if (!isValid) {
            alert(errorMessage);
            return;
        }



        const validationResult = await handleValidateBinUsage(
            selectedObjectType,
            selectedRows,
            selectedStorageLocationID
        );

        if (!validationResult.ok) {
            // CallMessage("error", validationResult.msg, "Validation Failed");
            return; // stop save if invalid
        }


        const saveData = {
            p_companyid: companyID,
            p_plantid: plantID,
            p_product_list: selectedProducts,
            p_id_location: locationID,
            p_user_name: userID,
            p_store_receive_date: dayjs(receivedDate).format('YYYY-MM-DD hh:mm:ss'),
            p_mode: 0,
            p_package_mode: selectedProductType[0],
            p_object_id: selectedObjectType.object_id,
            p_used_length_in_cm: usedLengthInCM,
            p_used_height_in_cm: usedHeightInCM,
            p_used_item_count: usedItemCount,
            p_user_id: localStorage.getItem('LoginID'),
        };
        setSaveLoading(true);
        await callApi(API_ENDPOINTS.PRODUCTION_SAVE_STORAGE_LOCATION_NEW_WAREHOUSE, 'POST',
            { 'Content-Type': 'application/json' }, saveData)
            .then(data => {
                if (data && data.length > 0) {
                    // setProductList(data);
                    handleFilterDataWithPackageMode();
                    CallMessage('success', 'Storage location saved successfully', 'Info');
                    setSaveLoading(false);

                    fetchWarhouseLocationListBySO(soNumber);

                    if (defaultParameterConfig.length > 0) {
                        const matchingRows = defaultParameterConfig.filter(
                            row => row.p_name === "FG Stock Update" && row.p_default_value_code === '1'
                        );

                        if (matchingRows.length > 0) { 
                            const parameter = {
                                p_companyid: companyID,
                                p_plantid: plantID,
                                p_user: userID,
                            };

                            callApi(Production_API_ENDPOINTS.FGStockUpdate, 'POST', { 'Content-Type': 'application/json' }, parameter)
                                .then(data => {
                                    if (data && data.length > 0) {
                                        if (data === "Stock updated successfully")
                                            CallMessage('success', 'FG Stock has been updated successfully', 'Info');

                                        else
                                            CallMessage('warning', data, 'Warning');
                                    }
                                })
                                .catch(error => {
                                    alert("API Error: " + error.message);
                                });
                        }
                    }
                }
            })
            .catch(error => {
                alert("API Error: " + error.message);
                setSaveLoading(false);
            });
    };




    //Reverse storage location status
    const reverseStorageLocation = async () => {

        if (!hasPermission(userPermissions, "FG Report", "Create")) {
            console.warn("User does not have permission to perform this action.");
            return; // Exit the function if permission is not granted
        }

        let isValid = true;
        let errorMessage = "";

        const selectedProducts = productList.filter((p) => selectedRows.includes(p.id_product));
        // Get distinct product_type values
        const selectedProductType = [...new Set(selectedProducts.map((p) => p.product_type))];

        let maxFgDate = null;

        if (selectedProducts.length > 0) {
            maxFgDate = selectedProducts
                .map((p) => dayjs(p.fg_date, "DD-MMM-YYYY")) // Convert `fg_date` to `dayjs` object
                .reduce((max, date) => (date.isAfter(max) ? date : max), dayjs(selectedProducts[0].fg_date, "DD-MMM-YYYY"));

            // Format maxFgDate for consistency
            maxFgDate = maxFgDate.format("YYYY-MM-DD HH:mm:ss");
        }

        // Convert receivedDate to `dayjs` and format it in the same way
        const p_store_receive_date = dayjs(receivedDate).format("YYYY-MM-DD HH:mm:ss");

        // Ensure `p_store_receive_date` is not less than `maxFgDate`
        if (maxFgDate && dayjs(p_store_receive_date).isBefore(dayjs(maxFgDate))) {
            isValid = false;
            errorMessage = "Storage Received date cannot be earlier than the maximum FG date.";
        } else if (!maxFgDate) {
            isValid = false;
            errorMessage = "No valid fg_date found in selected products.";
        }


        // Extracting required parameters
        const companyID = localStorage.getItem('companyid')?.trim();
        const userID = localStorage.getItem('userID')?.trim();
        const plantID = 1;  // Assuming plant ID is always 1
        const locationID = 0;



        // Validating each parameter
        if (!companyID) {
            isValid = false;
            errorMessage = "Company ID is missing.";
        } else if (!userID) {
            isValid = false;
            errorMessage = "User ID is missing.";
        } else if (!selectedProducts || selectedProducts.length === 0) {
            isValid = false;
            errorMessage = "Please select at least one product.";
        }
        //  else if (!locationID) {
        //     isValid = false;
        //     errorMessage = "Storage location is not selected.";
        // }


        let selectedProductslv = productList.filter(
            (p) =>
                selectedRows.includes(p.id_product) &&
                (!p.store_code || p.store_code.trim() === "")
        );

        let usedHeightInCM;
        let usedItemCount;

        if (binUsage.length > 0 && binUsage[0].is_stackable) {

            usedHeightInCM = selectedProductslv.reduce((sum, item) => {
                const size = item.size?.toString() || "";      // safe

                let firstVal;

                if (size.includes("X") || size.includes("x")) {
                    firstVal = parseFloat(size.toUpperCase().split("X")[0].trim());
                } else {
                    firstVal = parseFloat(size.trim());
                }
                return sum + (isNaN(firstVal) ? 0 : firstVal);
            }, 0);


            usedHeightInCM = (binUsage[0].used_height_in_cm - usedHeightInCM);

            if (selectedProductslv) {
                usedItemCount = binUsage[0].used_item_count - selectedProductslv.length;
            }

        }

        if (!isValid) {
            alert(errorMessage);
            return;
        }

        const saveData = {
            p_companyid: companyID,
            p_plantid: plantID,
            p_product_list: selectedProducts,
            p_id_location: locationID,
            p_user_name: userID,
            p_store_receive_date: dayjs(receivedDate).format('YYYY-MM-DD hh:mm:ss'),
            p_mode: 1,
            p_package_mode: selectedProductType[0],
            p_object_id: selectedObjectType.object_id,
            p_used_length_in_cm: usedLengthInCM,
            p_used_height_in_cm: usedHeightInCM,
            p_used_item_count: usedItemCount,
            p_user_id: localStorage.getItem('LoginID'),
        };

        await callApi(API_ENDPOINTS.PRODUCTION_SAVE_STORAGE_LOCATION, 'POST',
            { 'Content-Type': 'application/json' }, saveData)
            .then(data => {
                if (data && data.length > 0) {
                    // setProductList(data);
                    handleFilterDataWithPackageMode();
                    CallMessage('success', 'Storage location has reversed successfully', 'Info');


                }
            })
            .catch(error => {
                alert("API Error: " + error.message);
            });
    };

    // call message
    const CallMessage = (serverityval, msg, title) => {
        setSeverityvalue(serverityval);
        setMessageValue(msg);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };

    const handlecallProcess = (buttonName) => {
        if (buttonName === 'viewReport') {
            setViewReport(true);
            setdownloadReport(false);
            setViewList(false);
            fetchDataForReport();
        }
        else if (buttonName === 'addLocation') {
            setViewReport(false);
            setdownloadReport(false);
            setViewList(false);
        }
        else if (buttonName === 'save') {
            saveStorageLocation();
        }
        else if (buttonName === 'reverse') {
            reverseStorageLocation();
        }
        else if (buttonName === 'export') {
            handleExportToExcel();
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            await fetchDataForReport();
        };
        fetchData();
    }, [currentPage, pageSize, filterFromDate, filterToDate, setFilterFromDate, setFilterToDate]);

    const fetchDataForReport = async () => {
        const p_companyid = localStorage.getItem('companyid');
        const p_from_date = dayjs(filterFromDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');//dayjs(filterFromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_to_date = dayjs(filterToDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');//dayjs(filterToDate).format('YYYY-MM-DD hh:mm:ss');

        const para = {
            p_companyid: p_companyid,
            p_plantid: 1,
            p_from_date,
            p_to_date,
            p_so_number: soNumber,
            page: currentPage,
            pageSize: pageSize,
        };
        setLoading(true);
        try {
            const data = await callApi(API_ENDPOINTS.PRODUCTION_VIEW_STORAGE_LOCATION, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data) setReportDetail(data); // Set the fetched data to party list
        } catch (error) {
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    const excelColumns = [
        { header: "ORDER ID", key: "order_no" },
        { header: "ORDER DATE", key: "rorder_date" },
        { header: "CUSTOMER NAME", key: "rcustomer_name" },
        { header: "CONSIGNEE NAME", key: "rconsignee_name" },
        { header: "QUALITY", key: "rquality" },
        { header: "GSM", key: "rgsm" },
        { header: "WIDTH", key: "rwidth" },
        { header: "LENGTH", key: "rlength" },
        { header: "GRADE", key: "rgrade" },
        { header: "ORDER QTY", key: "rorder_qty" },
        { header: "ACHIEVED QTY", key: "rach_qty" },
        { header: "FG QTY", key: "rfg_qty" },
        { header: "REEL STOCK", key: "rreel_stock" },
        { header: "NO OF REAM IN BUNDLE", key: "rno_of_reams_per_bundle" },
        { header: "NO OF REAM", key: "rno_of_ream" },
        { header: "REAM WEIGHT", key: "rream_weight" },
        { header: "NO OF BUNDLE", key: "rnumber_of_bundle" },
        { header: "NO OF LOOSE", key: "rnumber_of_loose" },
        { header: "REAM STOCK", key: "rream_stock" },
        { header: "LOCATION", key: "rstorage_location" },
        { header: "PLANNING NO", key: "rplanning_number" },
        { header: "FG RECEVING DATE", key: "rstorage_date" },
        { header: "SALES OFFICE", key: "rsales_office" },
        { header: "DESTINATION", key: "rdestination" },
    ];


    const dateColumnIndexes = [1]; // ORDER DATE

    const handleExportToExcel = () => {
        exportToExcel({
            data: reportDetail,
            fileName: 'FG RECEIVING REPORT.xlsx',
            sheetName: 'FG DETAIL',
            columns: excelColumns,           // 🔁 Fixed name
            dateColumnIndexes,
        });




    };


    // filter oprations 
    const columns = ['id_product', 'product_code', 'item_code', 'gsm', 'size', 'grain', 'grade', 'weight', 'store_code', 'stored_date', 'customer_name', 'supplier_name', 'indent_no', 'product_type', 'fg_date', 'sync_date'];
    const autoCompleteColumns = ['id_product', 'product_code', 'item_code', 'gsm', 'size', 'grain', 'grade', 'weight', 'store_code', 'stored_date', 'customer_name', 'supplier_name', 'indent_no', 'product_type', 'fg_date', 'sync_date'];
    // , 'status'
    const handleFilterChangeTable = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const uniqueValues = {
        id_product: [...new Set(productList.map(row => row.id_product))],
        product_code: [...new Set(productList.map(row => row.product_code))],
        item_code: [...new Set(productList.map(row => row.item_code))],
        gsm: [...new Set(productList.map(row => row.gsm))],
        size: [...new Set(productList.map(row => row.size))],
        grain: [...new Set(productList.map(row => row.grain))],
        weight: [...new Set(productList.map(row => row.weight))],
        store_code: [...new Set(productList.map(row => row.store_code))],
        customer_name: [...new Set(productList.map(row => row.customer_name))],
        supplier_name: [...new Set(productList.map(row => row.supplier_name))],
        indent_no: [...new Set(productList.map(row => row.indent_no))],
        product_type: [...new Set(productList.map(row => row.product_type))],
        fg_date: [...new Set(productList.map(row => row.fg_date))],
        sync_date: [...new Set(productList.map(row => row.sync_date))],

    };

    const handleFilterData = () => {

        let SelectedSO = typeof selectedSalesOrderNumber === 'string'
            ? selectedSalesOrderNumber
            : selectedSalesOrderNumber?.so_number || '';
        const SaveData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_so_number: SelectedSO,
        }

        if (!viewReport) {
            setSaveLoading(true);
            callApi(API_ENDPOINTS.PRODUCTION_FILTER_DATA, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setProductList(data);
                        setViewList(true);
                        setSelectedRows([]);
                        loadProductionTrackingBySOAndCRNumber(0, SelectedSO, '');
                        setSaveLoading(false);
                    }
                    else {
                        setProductList([]);
                        setViewList(false);
                        setSelectedRows([]);
                        setSaveLoading(false);
                    }
                })
                .catch(error => {
                    alert(error.message);
                    setSaveLoading(false);
                });
        }


    }

    // const [soNumber,setSONumber]

    const handleFetchProductType = async () => {
        let SelectedSO = typeof selectedSalesOrderNumber === 'string'
            ? selectedSalesOrderNumber
            : selectedSalesOrderNumber?.so_number || '';

        if (SelectedSO !== null && SelectedSO !== '' && SelectedSO !== undefined) {
            await loadPackageTypeBySONumberAndID(null, SelectedSO);
            setIsOpenPackageMode(true);
            setSONumber(SelectedSO);

            await fetchWarhouseLocationListBySO(SelectedSO);

            let packagetype = await loadPackageTypeBySONumberAndID(null, SelectedSO);

            if (packagetype !== null && packagetype.length === 1 && SelectedSO !== null) {
                setSelectedPakcagetype(packagetype[0]);
                setSelectedPakcagetypeID(packagetype[0].line_no);
                setDisableFetchProduct(false);

                await LoadDetailsAfterPackageModeSelected(packagetype[0], SelectedSO);

            }

            setSelectedStorageLocation(null);
            setSelectedStorageLocationID(null);
            setViewList(false);


        }

    }


    const [selectedLocation, setSelectedLocation] = useState(null);
    const [open, setOpen] = useState(false);

    // ---------- SAMPLE DATA ----------
    const locations = [
        { code: "A1-01-01", capacity: 2000, used: 700, product: "Kraft 120 GSM", last_movement: "2025-11-18" },
        { code: "A1-01-02", capacity: 1800, used: 1650, product: "Kraft 100 GSM", last_movement: "2025-11-17" },
        { code: "A1-02-05", capacity: 2200, used: 2100, product: "MG Poster", last_movement: "2025-11-16" },
        { code: "B1-03-01", capacity: 2000, used: 950, product: "WTL", last_movement: "2025-11-15" },
        { code: "C1-02-03", capacity: 1500, used: 1500, product: "Liner Paper", last_movement: "2025-11-14" },
    ];

    // ---------- COLOR LOGIC ----------
    const getChipColor = (used, capacity) => {
        const pct = (used / capacity) * 100;

        if (pct <= 50) return colors.greenAccent[400];   // FREE
        if (pct <= 80) return colors.yellowAccent[400];  // MEDIUM
        return colors.redAccent[400];                    // FULL
    };

    const handleChipClick = (location) => {
        setSelectedLocation(location);
        setOpen(true);
    };



    const handleClose = () => {
        setOpen(false);
        setSelectedLocation(null);
    };

    const ClearDetailsDeselectSONumber = () => {
        setSelectedSalesOrderNumber(null);
        setSelectedSalesOrderNumberID(null);
        loadPackageTypeBySONumberAndID(null, null);
        setIsOpenPackageMode(false);
        setIsOpenWarehouseData(false);
        setViewList(false);
    }

    const LoadDetailsEnterNewSONumber = (newValue) => {
        setSelectedSalesOrderNumber({ so_number: newValue });
        setSelectedSalesOrderNumberID(null);
        fetchWarhouseLocationListBySO(newValue);
        setViewList(false);

    }

    const LoadDetailsSelecteSONumber = async (newValue) => {
        setSelectedSalesOrderNumber(newValue);
        setSelectedSalesOrderNumberID(newValue.id || null);

        setIsOpenPackageMode(true);
        await fetchWarhouseLocationListBySO(newValue.so_number);

        let packagetype = await loadPackageTypeBySONumberAndID(null, newValue.so_number);

        if (packagetype !== null && packagetype.length === 1 && newValue.so_number !== null) {
            setSelectedPakcagetype(packagetype[0]);
            setSelectedPakcagetypeID(packagetype[0].line_no);
            setDisableFetchProduct(false);

            await LoadDetailsAfterPackageModeSelected(packagetype[0], newValue.so_number);

        }
        setSelectedStorageLocation(null);
        setSelectedStorageLocationID(null);
        setViewList(false);
    }





    return (
        <>
            <Grid>
                <Grid item xs={12} sm={6} md={4} lg={2} mt={2} >

                    <Header title={selectedButtonName === 'addLocation' || 'save' ? "FG Storage Assignment" : "View And Download FG Report"} subtitle="" callback={handleCallBack} />


                    <Divider />
                    <>
                        <StorageLocationActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} disableSavebtn={disableSave} />
                        <Divider />
                    </>
                    <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue}
                        setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue}
                        setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />
                </Grid>

                {!viewReport ? (

                    <>
                        {hasPermission(userPermissions, "FG Report", "View") && (

                            <>
                                <Grid item xs={12} sm={6} md={4} lg={2} mt={1}>

                                 

                                    <Grid container spacing={2} mb={1} padding="10px 0 0 20px" alignItems="center">
                                        
                                        <Grid item xs={12} md={3.8} lg={2.5} xl={2}>
                                            <Autocomplete
                                                size="small"
                                                fullWidth
                                                freeSolo
                                                options={salesOrderNumber}
                                                value={selectedSalesOrderNumber}
                                                loading={ddloading}
                                                onChange={(event, newValue) => {
                                                    if (typeof newValue === "string") {

                                                        LoadDetailsEnterNewSONumber(newValue);

                                                    } else if (newValue) {
                                                        LoadDetailsSelecteSONumber(newValue);

                                                    } else {
                                                        ClearDetailsDeselectSONumber();
                                                    }
                                                }}
                                                onInputChange={(event, newInputValue) => {
                                                    if (newInputValue) {
                                                        setSelectedSalesOrderNumber({ so_number: newInputValue });
                                                    }
                                                }}
                                                getOptionLabel={(option) => (typeof option === "string" ? option : option?.so_number || "")}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        color="secondary"
                                                        label="Sales Order Number"
                                                        placeholder="Please select or enter SO"
                                                        required
                                                        variant="outlined"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3.8} lg={.5} xl={.5}>
                                            <Tooltip title="Fetch Package mode by Sales Order Number">

                                                <IconButton onClick={handleFetchProductType}>
                                                    <Update style={{ fontSize: "18px" }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>

                                        {isOpenPackageMode && (
                                            <>
                                               

                                                <Grid item xs={12} md={3.8} lg={2.5} xl={2}>
                                                    <Autocomplete
                                                        fullWidth
                                                        value={selectedPakcagetype}
                                                        onChange={handlePackageTypeChange}
                                                        size="small"
                                                        options={packagetypelist}
                                                        getOptionLabel={(option) =>
                                                            `${option.package_mode}`
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField color="secondary" 
                                                            label="Package Mode"
                                                            
                                                            required placeholder="Please select or enter Package Mode" {...params} variant="outlined" />
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} md={3.8} lg={2.5} xl={2.5}>
                                                    <Button
                                                        size="small"
                                                        variant="contained"
                                                        onClick={handleFilterDataWithPackageMode}
                                                        color="secondary"
                                                        sx={{ textTransform: 'none' }}
                                                        disabled={disableFetchProduct}
                                                        startIcon={<RefreshOutlined />}
                                                    >
                                                        Load FG Data
                                                    </Button>
                                                </Grid>
                                            </>
                                        )}





                                    </Grid>

                                    {isOpenWarehouseData && (
                                        <>
                                            <Grid item xs={12} sx={{ mt: 1 }}>
                                                <Divider />
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Box
                                                    sx={{
                                                        borderRadius: 1.5,
                                                        p: 1.5,
                                                        backgroundColor: colors.primary[400],
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        gap: 2,
                                                        flexWrap: "wrap"
                                                    }}
                                                >
                                                    {/* LEFT: Title */}
                                                    <Typography variant="h6" fontWeight="600" sx={{ whiteSpace: "nowrap" }}>
                                                        Warehouse Info
                                                    </Typography>

                                                    {/* RIGHT: Chips */}
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexWrap: "wrap",
                                                            gap: 1,
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        {warehouseLocationListBySO.map((loc) => {
                                                            // const pct = ((loc.used / loc.capacity) * 100).toFixed(1);
                                                            const chipColor = getChipColor(loc.used_space_cm, loc.max_space_cm);

                                                            return (
                                                                <Tooltip
                                                                    key={loc.code}
                                                                    title={
                                                                        <>
                                                                            <div><b>Location:</b> {loc.s_warehouse_location_code}</div>
                                                                            <div><b>Used:</b> {loc.used_space_cm} in cm</div>
                                                                            <div><b>Capacity:</b> {loc.max_space_cm} in cm</div>
                                                                            <div><b>Utilization:</b> {loc.utilization_percent}%</div>
                                                                        </>
                                                                    }
                                                                    arrow
                                                                >
                                                                    <Chip
                                                                        label={loc.s_warehouse_location_code}
                                                                        size="small"
                                                                        clickable
                                                                        onClick={() => handleChipClick(loc)}
                                                                        sx={{
                                                                            color: colors.grey[900],
                                                                            backgroundColor: chipColor,
                                                                            borderRadius: 1,
                                                                            fontSize: "12px",
                                                                            fontWeight: 600,
                                                                            px: 0.8,
                                                                            "&:hover": { opacity: 0.85 },
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            );
                                                        })}
                                                    </Box>
                                                </Box>
                                            </Grid>



                                            <Grid item xs={12} sx={{ mt: 0 }}>
                                                <Divider />
                                            </Grid>


                                            <Grid container spacing={2} padding="10px 0 0 20px" alignItems="center">
                                                <>
                                                    {/* <Grid item xs={12} md={2.5} lg={1.5} xl={1}>
                                                        <Typography variant="h6" fontSize={14} textAlign="left">
                                                            Storage Location
                                                        </Typography>
                                                    </Grid> */}

                                                    <Grid item xs={12} md={3.8} lg={2.5} xl={2}>
                                                        <FormControl fullWidth size="small">
                                                            <Autocomplete
                                                                fullWidth
                                                                value={selectedStorageLocation}
                                                                onChange={handleStorageLocationChange}
                                                                size="small"
                                                                options={storageLocation}
                                                                getOptionLabel={(option) => `${option.code || ''}`}
                                                                renderInput={(params) => (
                                                                    <TextField color="secondary"
                                                                    label="Storage Location"
                                                                    placeholder="Select storage location"
                                                                     required {...params} variant="outlined" />
                                                                )}
                                                            />
                                                        </FormControl>
                                                    </Grid>


                                                    {viewObjectType && (
                                                        <>
                                                            {/* <Grid item xs={12} md={2.5} lg={1} xl={1}>
                                                                <Typography variant="h6" fontSize={14} textAlign="left">
                                                                    Object Size
                                                                </Typography>
                                                            </Grid> */}

                                                            <Grid item xs={12} md={3.8} lg={3.2} xl={2.5}>
                                                                <FormControl fullWidth size="small">
                                                                    <Autocomplete
                                                                        fullWidth
                                                                        value={selectedObjectType}
                                                                        onChange={handleObjectTypeChange}
                                                                        size="small"
                                                                        options={filteredObjectTypeList}
                                                                        getOptionLabel={(o) =>
                                                                            `${o.object_type} (${o.object_unit}) → W:${o.object_width}  L:${o.object_length}  H:${o.object_height}`
                                                                        }
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                color="secondary"
                                                                                label="Object Type [W x L x H]"
                                                                                placeholder="Select object type"
                                                                                required
                                                                                variant="outlined"
                                                                            />
                                                                        )}
                                                                    />
                                                                </FormControl>
                                                            </Grid>

                                                        </>


                                                    )}


                                                    {/* <Grid item xs={12} md={2.5} lg={1.3} xl={1}>
                                                        <Typography variant="h6" fontSize={14} textAlign="left">
                                                            FG Receive Date
                                                        </Typography>
                                                    </Grid> */}

                                                    <Grid item xs={12} md={3.8} lg={2} xl={1.5}>
                                                        <FormControl fullWidth size="small">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                               <DatePicker
            id="ToDate"
            value={dayjs(receivedDate)}
            format="DD-MMM-YYYY"
            onChange={(date) => {
                if (date && !date.isAfter(dayjs(), 'day')) {
                    setReceivedDate(dayjs(date));
                }
            }}
            maxDate={dayjs()}
            slotProps={{
                textField: {
                    size: 'small',
                    label: 'FG Receive Date',
                },
            }}
        />
                                                            </LocalizationProvider>
                                                        </FormControl>
                                                    </Grid>
                                                </>
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </>
                        )}
                    </>
                ) : (<>
                    <Grid container padding="10px 0px 5px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                        <Grid item xs={12} sm={12} md={1} lg={1.2} xl={1.2} display="flex-start" justifyContent="center">
                            <Typography variant="h6" > {t('prod_winder_machine.filter_by')}
                                <CustomTooltip
                                    title={
                                        <span>
                                            <b>The data has been filtered based on the stored location, stored date.</b> <br />
                                        </span>}
                                >
                                    <IconButton sx={{ marginLeft: "5px" }}>
                                        <InfoOutlinedIcon sx={{ color: colors.redAccent[500], fontSize: "16px" }} />
                                    </IconButton>
                                </CustomTooltip> </Typography>
                        </Grid>

                        <Grid item xs={12} sm={11} md={1.5} lg={1.5} xl={1.5}>
                            <FormControl fullWidth size="small">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        style={{ marginLeft: '10px' }}
                                        id="FromDate"
                                        value={dayjs(filterFromDate)}
                                        onChange={(date) => handleFilterFromDate(date)}
                                        slotProps={{ textField: { size: 'small', } }}
                                        renderInput={(props) => <TextField {...props} />}
                                        autoFocus
                                        format="DD-MMM-YYYY"
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>



                        <Grid item xs={12} sm={11} md={1.5} lg={1.5} xl={1.5}>
                            <FormControl fullWidth size="small" >
                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                    <DatePicker
                                        id="ToDate"
                                        value={dayjs(filterToDate)}
                                        format="DD-MMM-YYYY"
                                        onChange={(date) => handleFilterToDate(date)}
                                        slotProps={{ textField: { size: 'small', } }}
                                        renderInput={(props) => <TextField {...props} />}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>


                    </Grid></>)}





                {viewList ? (<>
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                        <Grid container>
                            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <Grid container padding="0px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                        <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Select Storage Location
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                            <FormControl fullWidth size="small">
                                                <Autocomplete
                                                    fullWidth
                                                    value={selectedStorageLocation}
                                                    onChange={handleDepartmentChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={storageLocation}
                                                    getOptionLabel={(option) => `${option.storage_location_code || ''}`}
                                                    renderInput={(params) =>
                                                        <TextField required
                                                            {...params} variant="outlined" />}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={0.4} xl={0.3}>
                                            <Tooltip title="Add new operator" arrow>
                                                <IconButton style={{ fontSize: 5 }} size="small" color="secondary" onClick={handleOpenModal} >
                                                    <AddCircleIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                FG Receive Date
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                            <FormControl fullWidth size="small" >
                                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                    <DatePicker
                                                        id="ToDate"
                                                        value={dayjs(receivedDate)}
                                                        format="DD-MMM-YYYY"
                                                        onChange={(date) => setReceivedDate(dayjs(date))}
                                                        slotProps={{ textField: { size: 'small', } }}
                                                        renderInput={(props) => <TextField {...props} />}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                    </Grid>

                                </Grid>

                            </Grid> */}
                            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                        <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Store Receive Date
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                            <FormControl fullWidth size="small" >
                                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                    <DatePicker
                                                        id="ToDate"
                                                        value={dayjs(receivedDate)}
                                                        format="DD-MMM-YYYY"
                                                        onChange={(date) => setReceivedDate(dayjs(date))}
                                                        slotProps={{ textField: { size: 'small', } }}
                                                        renderInput={(props) => <TextField {...props} />}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        

                                    </Grid>

                                </Grid>

                            </Grid> */}
                        </Grid>
                    </Grid>

                    <Divider sx={{ marginTop: "5px", marginBottom: "10px" }} />



                    <Grid item xs={12} sm={6} md={12} lg={12} xl={12}>

                        {/* <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" > */}
                        <ResponsiveBox
                            customMaxHeight={{
                                xs: '60vh',  // Custom value for extra small devices
                                sm: '65vh',  // Custom value for small devices
                                md: '70vh',  // Custom value for medium devices
                                lg: '45vh',  // Custom value for large devices
                                xl: '68vh',  // Custom value for extra large devices
                            }}>
                            <CustomTableContainer colors={colors}>
                                <TableContainer>
                                    {saveLoading ? (
                                        <SkeletonTableLoader rows={5} columns={11} />
                                    ) : (
                                        <Table>
                                            <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                                <TableRow>
                                                    <TableCell sx={{ width: '50px' }}>
                                                        {/* <Checkbox 
                                                        size="small" 
                                                        style={{ color: "secondary" }}
                                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                                            checked={selectedRows.length === filteredData.length}
                                                            onChange={handleSelectAllClick}
                                                        /> */}

                                                        <Checkbox
                                                            size="small"
                                                            style={{ color: "secondary" }}
                                                            indeterminate={
                                                                selectedRows.length > 0 &&
                                                                selectedRows.length < selectableRows.length
                                                            }
                                                            checked={
                                                                selectableRows.length > 0 &&
                                                                selectedRows.length === selectableRows.length
                                                            }
                                                            onChange={handleSelectAllClick}
                                                        />

                                                    </TableCell>
                                                    <TableCell>PRODUCT CODE</TableCell>
                                                    <TableCell>QUALITY</TableCell>
                                                    <TableCell>GSM</TableCell>
                                                    <TableCell>SIZE</TableCell>
                                                    <TableCell>GRAIN</TableCell>
                                                    <TableCell>GRADE</TableCell>
                                                    <TableCell>WEIGHT</TableCell>
                                                    <TableCell>STORED LOCATION</TableCell>
                                                    <TableCell>FG RECEIVED DATE</TableCell>
                                                    <TableCell>CUSTOMER CODE</TableCell>
                                                    <TableCell>CONSIGNEE CODE</TableCell>
                                                    <TableCell>SO NUMBER</TableCell>
                                                    <TableCell>PRODUCT TYPE</TableCell>
                                                    <TableCell>PRODUCTION DATE</TableCell>
                                                    <TableCell>SYNC DATE</TableCell>
                                                    <TableCell>SYNC STATUS</TableCell>
                                                    {/* <TableCell>
                                                    <IconButton onClick={handleOpen}>
                                                        <Searchicon style={{ fontSize: "16px" }} />
                                                    </IconButton>
                                                    <Modal
                                                        open={openDateRangeDialog}
                                                        onClose={handleClose}
                                                        aria-labelledby="modal-modal-title"
                                                        aria-describedby="modal-modal-description"
                                                    >
                                                        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                            <TextField
                                                                label="Product Code"
                                                                name="product_code"
                                                                value={filters.product_code}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="QUALITY"
                                                                name="item_code"
                                                                value={filters.item_code}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />

                                                            <TextField
                                                                label="GSM"
                                                                name="gsm"
                                                                value={filters.gsm}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="SIZE"
                                                                name="size"
                                                                value={filters.size}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="GRAIN"
                                                                name="grain"
                                                                value={filters.grain}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="GRADE"
                                                                name="grade"
                                                                value={filters.grade}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="WEIGHT"
                                                                name="weight"
                                                                value={filters.weight}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="STORED LOCATION"
                                                                name="store_code"
                                                                value={filters.store_code}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="Customer Name"
                                                                name="customer_name"
                                                                value={filters.customer_name}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="Supplier Name"
                                                                name="supplier_name"
                                                                value={filters.supplier_name}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="Indent Number"
                                                                name="indent_no"
                                                                value={filters.indent_no}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <TextField
                                                                label="Product Type"
                                                                name="product_type"
                                                                value={filters.product_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                            <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                                Apply Filter
                                                            </Button>
                                                        </Box>
                                                    </Modal>
                                                </TableCell> */}
                                                </TableRow>
                                                <TableFilterRow
                                                    columns={columns}
                                                    filters={filters}
                                                    handleFilterChange={handleFilterChangeTable}
                                                    uniqueValues={uniqueValues}
                                                    autoCompleteColumns={autoCompleteColumns}
                                                />
                                            </TableHead>
                                            <TableBody>
                                                {filteredData.map((s, index) => (
                                                    <React.Fragment key={s.id}>
                                                        <TableRow sx={{ backgroundColor: index % 2 === 0 ? theme.palette.background.default : alpha(theme.palette.action.hover, 0.04), }}>
                                                            <TableCell sx={{ width: '50px' }}>
                                                                {/* <Checkbox
                                                                    size="small"
                                                                    checked={isSelected(s.id_product)}
                                                                      disabled={!!s.store_code}   // <-- disable when store_code has value
                                                                    onChange={(event) => handleRowCheckboxClick(event, s.id_product)}
                                                                /> */}
                                                                <div
                                                                    onClick={() => {
                                                                        if (s.store_code) {
                                                                            alert("This item is already allocated");
                                                                        }
                                                                    }}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <Checkbox
                                                                        size="small"
                                                                        checked={isSelected(s.id_product)}
                                                                        disabled={!!s.store_code}
                                                                        onChange={(event) =>
                                                                            handleRowCheckboxClick(event, s.id_product)
                                                                        }
                                                                    />
                                                                </div>

                                                            </TableCell>

                                                            <TableCell sx={{ minWidth: '120px' }}>{s.product_code}</TableCell>
                                                            <TableCell sx={{ minWidth: '120px' }}>{s.item_code}</TableCell>
                                                            <TableCell>{s.gsm}</TableCell>
                                                            <TableCell>{s.size}</TableCell>
                                                            <TableCell>{s.grain}</TableCell>
                                                            <TableCell>{s.grade}</TableCell>
                                                            <TableCell>{s.weight}</TableCell>
                                                            <TableCell>{s.store_code}</TableCell>
                                                            <TableCell>{s.stored_date}</TableCell>
                                                            <TableCell sx={{ minWidth: '180px' }}>{s.customer_name}</TableCell>
                                                            <TableCell sx={{ minWidth: '180px' }}>{s.supplier_name}</TableCell>
                                                            <TableCell>{s.indent_no}</TableCell>
                                                            <TableCell>{s.product_type}</TableCell>
                                                            <TableCell>{s.fg_date}</TableCell>
                                                            <TableCell>{s.sync_date}</TableCell>
                                                            <TableCell sx={{ textAlign: 'center' }}>
                                                                {/* <Chip
                                                                label={s.sync_status ? 'Synced' : 'Not Synced'}
                                                                color={s.sync_status ? 'success' : 'error'}
                                                                size="small"
                                                            /> */}
                                                                {s.sync_status ? <CheckIcon color="success" /> : <CloseIcon color="error" />}
                                                            </TableCell>


                                                        </TableRow>
                                                    </React.Fragment>
                                                ))}

                                            </TableBody>
                                        </Table>
                                    )}
                                </TableContainer>
                            </CustomTableContainer>
                        </ResponsiveBox>
                    </Grid>

                    {/* </Grid> */}
                    {/* </Grid>
                        </Grid>
                    </Grid> */}
                    {/* Footer Section */}
                    <Box padding={1.5} display="flex" justifyContent="space-between" backgroundColor={colors.primary[400]} mt={2}>
                        <Typography variant="h6">
                            Selected Rows: <strong>{selectedRows.length}</strong>
                        </Typography>
                        <Typography variant="h6">
                            Selected Quantity: <strong>{totalSelectedWeight}</strong>
                        </Typography>
                    </Box>

                    <Divider sx={{ marginTop: "10px", marginBottom: "0px" }} />
                    {/* 
                    {hasPermission(userPermissions, "FG Report", "Create") && (
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Grid container sx={{ justifyContent: 'flex-end' }}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <Grid container padding="0px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                            <Grid item xs={12} sm={11} md={3.8} lg={12} xl={12} >
                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                    <Button onClick={() => reverseStorageLocation()} size="small" variant="contained" sx={{ textTransform: 'none', backgroundColor: "#00acc1" }}>Reverse Storage Location</Button>
                                                    <Button onClick={() => saveStorageLocation()} size="small" variant="contained" color="secondary" sx={{ textTransform: 'none', marginLeft: '5px' }}> {saveLoading ? 'Saving...' : 'Save'}</Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )} */}

                    {/* <Typography>Tracking Details</Typography> */}
                    {/* tracking table */}
                    {/* <ResponsiveBox
                        customMaxHeight={{
                            xs: '60vh',  // Custom value for extra small devices
                            sm: '65vh',  // Custom value for small devices
                            md: '70vh',  // Custom value for medium devices
                            lg: '40vh',  // Custom value for large devices
                            xl: '70vh',  // Custom value for extra large devices
                        }}>
                        <CustomTableContainer colors={colors}>
                            <TableContainer>
                                <Table>
                                    <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                        <TableRow>
                                            
                                            <TableCell>SO NUMBER</TableCell>
                                            <TableCell>PARENT ROLL NO</TableCell>
                                            <TableCell>WINDER PROD.DATE</TableCell>
                                            <TableCell>WINDER SHIFT</TableCell>
                                            <TableCell>CHILD ROLL NUMBER</TableCell>
                                            <TableCell>QUALITY</TableCell>
                                            <TableCell>GSM</TableCell>
                                            <TableCell>WINDER REEL</TableCell>
                                            <TableCell>NUMBER OF CUTS</TableCell>
                                            <TableCell>REEL LENGTH</TableCell>
                                            <TableCell>REEL OD</TableCell>
                                            <TableCell>ACH QTY</TableCell>
                                            <TableCell>SIZE</TableCell>
                                            <TableCell>GRADE</TableCell>
                                            <TableCell>PROD TYPE</TableCell>
                                            <TableCell>REEL FG WT</TableCell>
                                            <TableCell>SHEET CONVERTION DATE</TableCell>
                                            <TableCell>TOTAL PALLET WT</TableCell>
                                            <TableCell>PALLET COUNT</TableCell>
                                           
                                            <TableCell>
                                                <IconButton onClick={handleOpen}>
                                                    <Searchicon style={{ fontSize: "16px" }} />
                                                </IconButton>
                                                <Modal
                                                    open={openDateRangeDialog}
                                                    onClose={handleClose}
                                                    aria-labelledby="modal-modal-title"
                                                    aria-describedby="modal-modal-description"
                                                >
                                                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                        <TextField
                                                            label="Product Code"
                                                            name="product_code"
                                                            value={filters.product_code}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="QUALITY"
                                                            name="item_code"
                                                            value={filters.item_code}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />

                                                        <TextField
                                                            label="GSM"
                                                            name="gsm"
                                                            value={filters.gsm}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="SIZE"
                                                            name="size"
                                                            value={filters.size}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="GRAIN"
                                                            name="grain"
                                                            value={filters.grain}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="GRADE"
                                                            name="grade"
                                                            value={filters.grade}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="WEIGHT"
                                                            name="weight"
                                                            value={filters.weight}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="STORED LOCATION"
                                                            name="store_code"
                                                            value={filters.store_code}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="Customer Name"
                                                            name="customer_name"
                                                            value={filters.customer_name}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="Supplier Name"
                                                            name="supplier_name"
                                                            value={filters.supplier_name}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="Indent Number"
                                                            name="indent_no"
                                                            value={filters.indent_no}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <TextField
                                                            label="Product Type"
                                                            name="product_type"
                                                            value={filters.product_type}
                                                            onChange={handleFilterChange}
                                                            variant="outlined"
                                                            fullWidth
                                                            margin="normal"
                                                        />
                                                        <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                            Apply Filter
                                                        </Button>
                                                    </Box>
                                                </Modal>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {productionTracking.map((s) => (
                                            <React.Fragment key={s.id}>
                                                <TableRow>
                                                    

                                                    <TableCell>{s.so_number}</TableCell>
                                                    <TableCell>{s.parent_roll_number}</TableCell>
                                                    <TableCell>{s.winder_date}</TableCell>
                                                    <TableCell>{s.w_shift_code}</TableCell>
                                                    <TableCell>{s.cr_numbers}</TableCell>
                                                    <TableCell>{s.quality}</TableCell>
                                                    <TableCell>{s.gsm}</TableCell>
                                                    <TableCell>{s.winder_reel}</TableCell>
                                                    <TableCell>{s.cut_sheet}</TableCell>
                                                    <TableCell>{s.reel_length}</TableCell>
                                                    <TableCell>{s.reel_od}</TableCell>
                                                    <TableCell>{s.ach_qty}</TableCell>
                                                    <TableCell>{s.width} X {s.length}</TableCell>
                                                    <TableCell>{s.grade}</TableCell>
                                                    <TableCell>{s.prod_mode}</TableCell>
                                                    <TableCell>{s.reel_weightment_wt}</TableCell>
                                                    <TableCell>{s.s_date}</TableCell>
                                                    <TableCell>{s.total_pallet_wt}</TableCell>
                                                    <TableCell>{s.pallet_count}</TableCell>
                                                   


                                                </TableRow>
                                            </React.Fragment>
                                        ))}

                                    </TableBody>
                                </Table>

                            </TableContainer>
                        </CustomTableContainer>
                    </ResponsiveBox> */}
                </>) : (null)}
                {viewReport ? (<><ViewStorageLocationReportBySONumber reportDetail={reportDetail} loadingOrderItemDet={loading} /> </>) : (null)}
                {isModalOpen && < AddStorageLocation onClose={handleCloseModal} open={isModalOpen} />}

                {/* ---------- DIALOG POPUP DETAILS ---------- */}

                {/* <Dialog
                    open={open}
                    onClose={handleClose}
                    maxWidth="xs"
                    fullWidth
                    PaperProps={{
                        sx: {
                            backgroundColor: colors.primary[400],
                            borderRadius: 2,
                        },
                    }}
                >
                    {selectedLocation && (
                        <>
                            <DialogTitle sx={{ fontWeight: "bold", color: colors.blueAccent[200] }}>
                                Location: {selectedLocation.code}
                            </DialogTitle>

                            <DialogContent dividers sx={{ color: colors.grey[100] }}>
                                <Stack spacing={2}>
                                    <Typography variant="body2">
                                        <b>Capacity:</b> {selectedLocation.capacity} kg
                                    </Typography>

                                    <Typography variant="body2">
                                        <b>Used:</b> {selectedLocation.used} kg
                                    </Typography>

                                    <Typography variant="body2">
                                        <b>Free:</b> {selectedLocation.capacity - selectedLocation.used} kg
                                    </Typography>

                                    <Divider sx={{ borderColor: colors.grey[600] }} />

                                    
                                    <Typography variant="body2">
                                        <b>Utilization:</b>{" "}
                                        {((selectedLocation.used / selectedLocation.capacity) * 100).toFixed(1)}%
                                    </Typography>

                                    <LinearProgress
                                        variant="determinate"
                                        value={(selectedLocation.used / selectedLocation.capacity) * 100}
                                        sx={{
                                            height: 7,
                                            borderRadius: 5,
                                            backgroundColor: colors.grey[700],
                                            "& .MuiLinearProgress-bar": {
                                                backgroundColor: colors.blueAccent[300],
                                            },
                                        }}
                                    />

                                    <Divider sx={{ borderColor: colors.grey[600] }} />

                                    <Typography variant="body2">
                                        <b>Product:</b> {selectedLocation.product}
                                    </Typography>

                                    <Typography variant="body2">
                                        <b>Last Movement:</b> {selectedLocation.last_movement}
                                    </Typography>
                                </Stack>
                            </DialogContent>
                        </>
                    )}
                </Dialog> */}

            </Grid>
        </>
    );
};
export default AddStorageLocationForFGWarehouse;